import React from 'react';
import { IconSurgePremium } from '../../../shared';
import { Row } from '@amzn/atoz-web/Row';
import { View } from '@amzn/atoz-web/View';
import { Text } from '@amzn/atoz-web/Text';
import { Link } from '@amzn/atoz-web/Link';
import { useTranslation } from 'react-i18next';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { Routes } from '@amzn/atoz-shiftapp-initializer';
import { useNavigate } from '../../../../hooks';
export var ShiftPayLink = function (_a) {
    var surgePayText = _a.surgePayText;
    var t = useTranslation().t;
    var navigate = useNavigate();
    return (React.createElement(View, { dataTestId: "ShiftPayLink" },
        React.createElement(PayCard, null,
            React.createElement(Text, null,
                React.createElement(Link, { onClick: function () { return navigate(Routes.Pay, { external: true }); }, dataTestId: "ShiftPayLink-viewPayPageLink" }, t('shift_management_features_ShiftDetailsModal_viewPayPage'))),
            surgePayText && (React.createElement(Row, { alignItems: "center" },
                React.createElement(SurgePayText, { dataTestId: "ShiftPayLink-surgePayText" }, surgePayText),
                React.createElement(IconSurgePremium, { dataTestId: "ShiftPayLink-surgeIcon" }))))));
};
var PayCard = styledWithTheme(View)(function (_a) {
    var theme = _a.theme;
    return "\n    align-items: center;\n    box-shadow: 0 0 5px 1px ".concat(theme.selectors.color('neutral20'), ";\n    display: flex;\n    justify-content: space-between;\n    padding: ").concat(theme.selectors.space('S300'), "px;\n");
});
var HeaderRow = styledWithTheme(Row)(function (_a) {
    var theme = _a.theme;
    return "\n  justify-content: space-between;\n  margin-bottom: ".concat(theme.selectors.space('S200'), "px;\n  ");
});
var SurgePayText = styledWithTheme(Text)(function (_a) {
    var theme = _a.theme;
    return "\n    font-weight: bold;\n    margin-right: ".concat(theme.selectors.space('S200'), "px;\n  ");
});
